import React, {useState, useEffect} from 'react';
import { Triangle } from 'react-loader-spinner';
import './Loading.css';

const Loading = () => {

  /*Loader*/
  const [loading, setLoading] = useState(true);

  useEffect(()=>{
    setLoading(true)
    setTimeout(()=>{
      setLoading(false)
    },4000)
  },[])

  if(!loading){
    return null;
  }
  return (
    <div className='loader'>
    <Triangle
        height = "300"
        width = "300"
        radius = "9"
        color = 'white'
        ariaLabel = 'three-dots-loading'     
        wrapperStyle
        wrapperClass
    />
    </div>
  )
}

export default Loading;